import { render } from "./SzUpload.vue?vue&type=template&id=bbbab9c0&scoped=true"
import script from "./SzUpload.vue?vue&type=script&lang=ts"
export * from "./SzUpload.vue?vue&type=script&lang=ts"

import "./SzUpload.vue?vue&type=style&index=0&id=bbbab9c0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-bbbab9c0"

export default script